import { MODEL as MODEL_PROJECT } from '_modules/project/components/ProjectModel';

export const _DELETE_TAB_ = 'Delete:Tab';
export const _LOAD_MODEL_ = 'Load:QuotationModel';
export const _OPEN_MODAL_ = 'Open:Quotation';
export const _LOAD_COMMENTS_ = 'Load:QuotationComments';
export const _SAVE_CONTRACT_ = 'Save:Contract';
export const _OPEN_MODEL_MODAL_ = 'Open:QuotationModel';
export const _DELETE_QUOTATION_ = 'Delete:Quotation';
export const _OPEN_ASSIGN_MODAL_ = 'Open:AssignQuotation';
export const _OPEN_CONFIRMATION_ = 'Open:Confirmation';
export const _OPEN_PRODUCT_MODAL_ = 'Load:Product';
export const _LOAD_TEMPLATE_MODEL_ = 'Load:TemplateModel';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _UPDATE_QUOTATION_ROWS_ = 'Update:UpdateQuotation';
export const _OPEN_EDITOR_TEXT_MODAL_ = 'Load:EditorText';
export const _SAVE_EDITOR_TEXT_MODAL_ = 'Save:EditorText';
export const _OPEN_OBLIGATION_MODAL_ = 'Open:ObligationModal';
export const _SAVE_QUOTATION_SUCCESS_ = 'Save:QuotationSuccess';
export const _SET_OBLIGATION_IN_QUOTATION_ = 'Set:ObligationModal';
export const _CANCEL_PRICE_TABLE_CHANGE_ = 'Cancel:PriceTableChange';

export const OPTIONS_CONFIRMATION_MODAL = {
  approved: {
    callback: 'approveQuotation',
    title: 'Confirme aprovação do orçamento',
    message: 'Tem certeza que deseja aprovar este orçamento?<br/>Ao fazê-lo será enviado um e-mail ao cliente com o contrato.',
  },
  deleteTab: {
    callback: 'deleteTab',
    title: 'Confirme exclusão da aba',
    message: 'Tem certeza que deseja excluir esta aba?',
  },
  delete: {
    callback: 'deleteRow',
    title: 'Confirme exclusão de orçamento',
    message: 'Tem certeza que deseja excluir esse orçamento?',
  },
  approvedPriceTable: {
    cancel: 'cancelUpdatePriceTable',
    callback: 'updatePriceTable',
    title: 'Confirme alteração da tabela de preço',
    message: 'Deseja realmente mudar a tabela de preço?<br/>Isso afetará todos os valores do orçamento com base na nova tabela.',
  },
};

export const PRODUCT_UNITS_OPTIONS = [
  { id: null, name: null, description: '' },
];

export const TYPE_OPTIONS = [
  { id: null, slug: null, name: null },
];

export const CLASS_OPTIONS = [{
  id: null,
  name: null,
  slug: null,
  type_id: null,
  file_id: null,
}];

export const PAYMENT_TYPE_OPTIONS = [
  { id: 2, name: 'À Vista', slug: 'a-vista' },
  { id: 7, name: 'À Prazo', slug: 'a-prazo' },
];

export const ROW = {
  id: null,
  step: 0.01,
  order: 0,
  total: 1.00,
  value: 1.00,
  quantity: 1,
  unit_type: 'm²',
  description: null,
  variation_id: null,
  warranty_period: null,
  warranty_type: null,
};

export const PAYMENT = {
  id: null,
  total: null,
  parcel: 1,
  group_id: null,
  entree_type: 'pct',
  payment_type: 'forward',
  entree_value: null,
  parcel_value: null,
};

export const PROJECT_DIMENSIONS = {
  type: null,
  width: null,
  height: null,
  lengths: null,
  template_id: null,
};

export const PAYMENT_SPOT = { ...PAYMENT, ...{ entree_value: 30, parcel: 8, payment_type: 'spot' } };

export const GROUP = {
  id: null,
  tax: null,
  name: 'Principal',
  rows: [{ ...ROW }],
  model: 0,
  total: 0.00,
  parcel: 1,
  weight: null,
  volume: null,
  items_included: null,
  type_id: null,
  discount: 0.00,
  subtotal: 0.00,
  remaining: 0.00,
  total_tax: 0.00,
  payment_id: 1,
  model_name: null,
  obligations_buyer: null,
  obligations_seller: null,
  started_date: null,
  installments_by_types: {
    forward: [
      { ...PAYMENT, ...{ entree_value: 30, parcel: 6 } },
      { ...PAYMENT, ...{ entree_value: 40, parcel: 8 } },
      { ...PAYMENT, ...{ entree_value: 50, parcel: 10 } },
    ],
    spot: [{ ...PAYMENT_SPOT }],
  },
  payment_info: '',
  payment_spot: 0,
  delivery_date: null,
  discount_type: 'pct',
  shipping_company: null,
  project_dimensions: { ...PROJECT_DIMENSIONS },
};

export const SIGNATURE = ['Financeiro', 'Comercial', 'Contratante', 'Contratado'];

export const SERVICE = {
  goal: null,
  price_table: null,
  service_type: null,
  terrain_type: null,
  project_width: 0,
  project_length: 0,
  has_competitor: null,
  installation_date: null,
  rating: 0,
};

export const DEAL = {
  quotation_id: null,
  deals: {
    team: null,
    food: null,
    tools: null,
    shipping: null,
    tool_type: null,
    sub_floor: null,
    earthwork: null,
    floor_type: null,
    comment: null,
    common_sand: null,
    washed_sand: null,
    accommodation: null,
    grass_removal: null,
    earthwork_tool: null,
    floor_adjustments: null,
    scaffolding: null,
    displacement: null,
  },
};

export const INSTALLATION = {
  car_type: null,
  road_type: null,
  access_type: null,
  weekend_time: null,
  installation_time: null,
  comment: null,
};

export const FILE = {
  id: null,
  file: {
    name: null,
    url: null,
  },
};

export const FILES_DEFAULT = [{ ...FILE }, { ...FILE }, { ...FILE }, { ...FILE }];

export const STATUS = {
  name: '',
  slug: '',
};

export const FILES = {
  plant_local: [...FILES_DEFAULT],
  access_local: [...FILES_DEFAULT],
  medition_local: [...FILES_DEFAULT],
  installation_local: [...FILES_DEFAULT],
};

export const MODEL = {
  id: null,
  status_id: 1,
  step: 'client',
  groups: [{ ...GROUP }],
  type_id: 1,
  drive_id: null,
  comments: [],
  contract: null,
  valid_at: null,
  customer_id: null,
  project_id: null,
  project: { ...MODEL_PROJECT },
  company: null,
  show_payments: 1,
  show_classes: null,
  company_information: null,
  customer_name: null,
  customer: {},
  signature: { ...SIGNATURE },
  created_user: {
    name: null,
  },
  steps: { step: null },
  started_date: null,
  deal: { ...DEAL },
  service: { ...SERVICE },
  installation_info: { ...INSTALLATION },
  files: { ...FILES },
  status: { ...STATUS },
};

export const MODEL_EDITOR_TEXT = {
  id: null,
  name: null,
  selected: null,
  detail_id: null,
};

export const TEMPLATE_ROW = {
  id: null,
  template_id: null,
  group_id: null,
  variation_id: null,
  variation: {
    name: null,
    warranty_period: null,
    warranty_type: null,
    price: null,
  },
  step: 0.01,
  order: 0,
  quantity: 1,
};

export const TEMPLATE_GROUP = {
  id: null,
  name: 'Principal',
  template_id: null,
  obligations_buyer: null,
  obligations_seller: null,
  items_included: null,
  discount: 0.00,
  payment_id: 1,
  installments_by_types: {
    forward: [
      { ...PAYMENT, ...{ entree_value: 30, parcel: 6 } },
      { ...PAYMENT, ...{ entree_value: 40, parcel: 8 } },
      { ...PAYMENT, ...{ entree_value: 50, parcel: 10 } },
    ],
    spot: [{ ...PAYMENT_SPOT }],
  },
  payment_info: '',
  payment_spot: 0,
  discount_type: 'pct',
  rows: [{ ...TEMPLATE_ROW }],
};

export const TEMPLATE_MODEL = {
  id: null,
  name: null,
  created_by: null,
  type_id: null,
  groups: [{ ...TEMPLATE_GROUP }],
};
